
export class UnauthorizedInterceptor {
    /*
      sessionStorage keys: unauthorizedCount,lastUnauthorizedAt, isRedirecting e lastHandledAt (opcional: debounce leve)
    */
    static maxUnauthorized = 1;
    static sessionWindowMs = 5 * 60 * 1000; // 5 min
    static debounceMs = 50; // opcional: filtra rajadas no mesmo tick

    static now() {
        return Date.now();
    }

    static getNumber(key, fallback = 0) {
        const v = sessionStorage.getItem(key);
        const n = v === null ? fallback : Number(v);
        return Number.isFinite(n) ? n : fallback;
    }

    static getBool(key) {
        return sessionStorage.getItem(key) === "true";
    }

    static set(key, value) {
        sessionStorage.setItem(key, String(value));
    }

    static resetWindow() {
        // Reseta a janela de contagem (sem apagar o flag de redirect)
        this.set("unauthorizedCount", 0);
        this.set("lastUnauthorizedAt", this.now());
    }

    static isSessionExpired() {
        const last = this.getNumber("lastUnauthorizedAt", 0);
        if (!last) return true;
        return (this.now() - last) > this.sessionWindowMs;
    }

    static handleUnauthorized() {
        const now = this.now();
        const lastHandledAt = this.getNumber("lastHandledAt", 0); // 0) Debounce leve para evitar múltiplas chamadas no mesmo tick
        if (now - lastHandledAt < this.debounceMs) return;
        this.set("lastHandledAt", now);
        if (this.getBool("isRedirecting")) return; // 1) Se já estamos redirecionando, não faz mais nada
        if (this.isSessionExpired()) { // 2) Se a janela expirou, zera contagem e reinicia a janela
            this.resetWindow();
        }
        let count = this.getNumber("unauthorizedCount", 0); // 3) Leia o contador atual
        if (count >= this.maxUnauthorized) { // 4) Se já atingiu o limite, NÃO incremente — apenas dispare redirect uma única vez
            this.set("unauthorizedCount", this.maxUnauthorized); // Capagem por segurança e redireciona (apenas uma vez)
            return this.redirectToLogin();
        }
        count = Math.min(this.maxUnauthorized, count + 1);// 5) Ainda não atingiu o limite → incremente (capado para no máximo maxUnauthorized)
        this.set("unauthorizedCount", count);
        this.set("lastUnauthorizedAt", now);
        console.warn(`UnauthorizedInterceptor: Unauthorized (${count}/${this.maxUnauthorized})`);
        // 6) Se após incrementar atingiu o limite → marque redirect ANTES de qualquer outra ação concorrente
        if (count >= this.maxUnauthorized) {
            console.warn("UnauthorizedInterceptor: Sessão expirada. Redirecionando para login...");
            return this.redirectToLogin();
        }
    }

    static redirectToLogin() {
        // Dupla verificação para cenários concorrentes
        if (this.getBool("isRedirecting")) return;
        // Marque o redirect primeiro para bloquear incrementos subsequentes
        this.set("isRedirecting", true);
        // Mantenha o contador capado (evita aparecer 4/3 nos logs)
        this.set("unauthorizedCount", this.maxUnauthorized);
        if (typeof window !== "undefined") {
            try {
                localStorage.clear();
                sessionStorage.clear();
            } catch {
                console.log('UnauthorizedInterceptor: erro ao tentar limpar storage')
            }
            window.location.href = "/login";
        } else {
            console.error("UnauthorizedInterceptor: sessão expirada - redirecionar ao Login.");
        }
    }

}